import React, { useState } from 'react';
import styled from 'styled-components';
import { useModalStore } from '../../shared/store/portal/modalStore';
import { slideInFromRightWeighted } from '../../shared/component/Animation';
import HeadlessBtn from '../../shared/component/headless/button/HeadlessBtn';
import { BlackFullWidthBtn } from '../../shared/component/headless/button/BtnBody';
import { useWorkListStore } from '../../shared/store/WorkListStore';
import FilterStationWorkType from './FilterStationWorkType';
import FilterStationProdYear from './FilterStationProdYear';
import { WorkFilterData } from '../../shared/dto/EntityRepository';
import { useWorkPropertyVisible } from '../../shared/hooks/useApi/useWorkPropertyVisible';
import { getModalMessage } from '../../shared/constants/modalMessages';
import { getBtnName } from '../../shared/constants/btnNames';
import { paperTextureModal } from '../../shared/component/paperTexture';
import { useWorkTagStore } from '../../shared/store/workTagStore';
import FilterStationMemberCredit from './FilterStationMemberCredit';

const WorkImport: React.FC = () => {
  const { isClosing, clearModal } = useModalStore();
  const filterData = useWorkListStore((s) => s.filterData);
  const setFilterData = useWorkListStore((s) => s.setFilterData);
  const { workPropertyVisible } = useWorkPropertyVisible();
  const selectedTags = useWorkTagStore((s) => s.selectedTags);
  const [currentFilter, setCurrentFilter] = useState<WorkFilterData>(filterData);

  if (!filterData) return null;

  const handleSubmit = () => {
    setFilterData({
      ...currentFilter,
      tagIds: selectedTags.map((t) => t.id),
    });
    clearModal(400);
  }

  return (
    <RightModalFrame
      onClick={(e) => e.stopPropagation()}
      $isClosing={isClosing}
    >
      <FilterStationComp>
        <FilterStationTitle>{getModalMessage('FILTER_STATION_TITLE')}</FilterStationTitle>
        <FilterStationMemberCredit
          currentFilter={currentFilter}
          setCurrentFilter={setCurrentFilter}
        />
        <FilterStationProdYear currentFilter={currentFilter} setCurrentFilter={setCurrentFilter} />
        {workPropertyVisible?.workType && (
          <FilterStationWorkType currentFilter={currentFilter} setCurrentFilter={setCurrentFilter} />
        )}
          <HeadlessBtn
            value={getBtnName('APPLY')}
            handleClick={handleSubmit}
            StyledBtn={ApplyButton}
          />
      </FilterStationComp>
    </RightModalFrame>
  );
};

const RightModalFrame = styled.div<{ $isClosing: boolean }>`
  position: absolute;
  right: clamp(20px, 2vw, 30px);
  bottom: clamp(70px, 10vh, 100px);
  width: 22vw;
  min-width: 300px;
  height: clamp(55vh, fit-content, 90vh);

  padding: 20px;

  opacity: ${({ $isClosing }) => ($isClosing ? 0 : 1)};
  transform: ${({ $isClosing }) =>
    $isClosing
      ? 'translateX(100%)'
      : 'translateX(0)'
  };

  transition: all 0.6s ease-out;
  ${paperTextureModal}
  ${slideInFromRightWeighted}
`;


const FilterStationComp = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: clamp(10px, 3vh, 20px);
`
const FilterStationTitle = styled.div`
  margin-bottom: 1.5vh;
  ${({ theme }) => theme.typography.Body_02_1};
`

const ApplyButton = styled(BlackFullWidthBtn)`
  margin: 10px 0px;
`;

export default WorkImport;
